var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#949A6C;}\n\t.st1{fill:#444444;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#BF764D;}\n\t.st4{fill:#5D7895;}\n\t.st5{fill:#D3DAE0;}\n\t.st6{fill:#F5F3E7;}\n\t.st7{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.49,180.01h8.69v1.51h-7.08v6.14h6.98v1.51h-6.98v6.87h7.2v1.51h-8.81V180.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.79,190.18l-4.32,7.37h-1.73l5.16-8.86l-5.11-8.69h1.82l4.2,7.15l4.18-7.15h1.75l-5.06,8.64l5.26,8.9 h-1.8L262.79,190.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.11,180.01h4.37c3.41,0,5.54,1.9,5.54,4.97c0,3.02-2.14,4.94-5.54,4.94h-2.76v7.63h-1.61V180.01z  M278.41,188.41c2.52,0,3.98-1.22,3.98-3.43s-1.46-3.46-3.98-3.46h-2.69v6.89H278.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.5,180.01h8.69v1.51h-7.08v6.14h6.98v1.51h-6.98v6.87h7.2v1.51h-8.81V180.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.18,189.37v8.18h-1.61v-17.55h4.3c3.19,0,5.21,1.8,5.21,4.73c0,2.66-2.02,4.66-5.21,4.66h-0.74 l7.08,8.16h-2.04L306.18,189.37z M308.75,188.02c2.35,0,3.7-1.32,3.7-3.29c0-2.02-1.34-3.29-3.7-3.29h-2.57v6.58H308.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.69,181.52h-4.63v-1.51h10.87v1.51h-4.63v16.03h-1.61V181.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.02,180.01h1.61v17.55h-1.61V180.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.53,197.55v-1.54c1.18,0.14,2.21,0.19,3.07,0.19c2.78,0,4.2-1.1,4.2-3.19c0-1.42-0.67-2.42-2.42-3.53 l-1.92-1.2c-1.92-1.2-2.81-2.57-2.81-4.3c0-2.62,1.97-4.18,5.3-4.18c0.67,0,1.44,0.05,2.38,0.19v1.46 c-0.89-0.12-1.63-0.19-2.33-0.19c-2.45,0-3.74,0.94-3.74,2.69c0,1.22,0.65,2.11,2.18,3.07l1.82,1.13 c2.16,1.34,3.17,2.88,3.17,4.82c0,2.98-2.14,4.75-5.81,4.75C343.69,197.75,342.78,197.7,341.53,197.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.1,180.01h8.69v1.51h-7.08v6.14h6.98v1.51h-6.98v6.87h7.2v1.51h-8.81V180.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.46,208.81h4.37c3.31,0,5.42,1.61,5.42,4.37c0,1.9-0.98,3.29-2.66,3.96c2.09,0.58,3.29,2.14,3.29,4.34 c0,3-2.16,4.87-5.57,4.87h-4.85V208.81z M257.83,216.51c2.4,0,3.82-1.2,3.82-3.17c0-1.94-1.42-3.07-3.82-3.07h-2.76v6.24H257.83z  M258.24,224.89c2.5,0,3.98-1.18,3.98-3.46c0-2.28-1.46-3.46-4.18-3.46h-2.98v6.91H258.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.97,208.81h8.69v1.51h-7.08v6.14h6.98v1.51h-6.98v6.87h7.2v1.51h-8.81V208.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.05,208.81h1.66l8.81,14.74v-14.74h1.56v17.55h-1.66l-8.81-14.74v14.74h-1.56V208.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.15,208.81h8.69v1.51h-7.08v6.14h6.98v1.51h-6.98v6.87h7.2v1.51h-8.81V208.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.22,208.81h8.67v1.51h-7.06v6.19h6.86v1.54h-6.86v8.3h-1.61V208.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.69,208.81h1.61v17.55h-1.61V208.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.02,210.32h-4.63v-1.51h10.87v1.51h-4.63v16.03h-1.61V210.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.2,226.35v-1.54c1.18,0.14,2.21,0.19,3.07,0.19c2.78,0,4.2-1.1,4.2-3.19c0-1.42-0.67-2.42-2.42-3.53 l-1.92-1.2c-1.92-1.2-2.81-2.57-2.81-4.3c0-2.62,1.97-4.18,5.3-4.18c0.67,0,1.44,0.05,2.38,0.19v1.46 c-0.89-0.12-1.63-0.19-2.33-0.19c-2.45,0-3.74,0.94-3.74,2.69c0,1.22,0.65,2.11,2.18,3.07l1.82,1.13 c2.16,1.34,3.17,2.88,3.17,4.82c0,2.98-2.14,4.75-5.81,4.75C357.36,226.54,356.45,226.5,355.2,226.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 165.62,
    cy: 194.07,
    r: 33.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.46,194.91c2.61-4.21,4.18-8.15,4.18-11.53c0-9.61-6.7-16.52-16.85-16.42 c-14.36,0-27.54,9.94-27.54,35.53v30.8c-4.52,4.06-6.05,5.47-6.88,6.15c-6.44,5.21-10.81,10.9-21.5,10.9 c-14.9,0-23.65-11.23-23.65-29.05c0-3.12,0.27-6.01,0.8-8.64h40.57c3.35-10.15-4.64-19.87-20.2-19.87 c-16.63,0-30.46,12.31-30.46,30.67s13.72,29.59,28.84,29.16c16.18-0.46,22.61-8.64,23.98-9.83c1.19-1.03,4.27-3.81,4.27-3.81 c1.43-1.14,2.58-2.51,4.24-3.86v16.53H123v-13.89c3.33,10.87,11.98,14.65,19.22,14.65c15.12,0,28.19-12.64,28.19-29.92 C170.41,209.37,163.72,199.15,154.46,194.91z M83.27,194.07c8.53,0,13.18,4.64,13.18,10.8c0,5.29-4.21,6.48-9.29,6.48H63.29 C65.91,200.31,73.14,194.07,83.27,194.07z M142.11,168.26c9.18-0.11,15.23,5.94,15.23,15.12c0,3.37-1.44,7.15-3.82,11.12 c-2.76-1.12-5.73-1.73-8.81-1.73c-8.85,0-18.32,4.26-21.71,13.77v-10.1C123,175.71,130.12,168.26,142.11,168.26z M123,214.37 c0-13.82,10.58-19.66,18.58-19.66c3.93,0,7.22,1.05,9.92,2.89c-7,9.97-18.96,20.68-28.49,28.6V214.37z M141.36,250.77 c-8.04,0-18.2-5.86-18.35-22.93c10.5-8.94,22.23-19.84,29.27-29.66c6.25,4.83,9.06,14.19,9.06,24.51 C161.34,238.46,153.99,250.77,141.36,250.77z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 174.91,
    cy: 246.27,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.52,173.43c-2.55-3.31-3.71-5.8-3.71-8.93c0-5.68,4-9.69,12.06-9.69c1.33,0,2.9,0.12,5.1,0.41v2.15 c-1.97-0.29-3.48-0.41-4.81-0.41c-7.02,0-10.15,3.07-10.15,7.48c0,3.31,1.74,5.86,4.76,9.51l12.47,15.08 c2.44-3.6,4.23-8.29,5.28-13.57l2.32,0.46c-1.22,5.62-3.07,10.55-6.15,14.85l5.62,6.79h-3.02l-4.23-5.1 c-3.19,3.13-7.71,5.39-12.93,5.39c-7.54,0-12.41-4.93-12.41-11.95C167.72,179.52,171.83,175.34,177.52,173.43z M178.91,175.22 c-5.1,1.57-8.93,4.93-8.93,10.56c0,5.8,4.12,9.86,10.15,9.86c3.83,0,8.41-1.62,11.54-4.93l-12.3-14.91L178.91,175.22z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.40e30d3af6fb2947ddc9fdf1dc83e5c0.svg";
export { ForwardRef as ReactComponent };